import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const ToastContext = createContext(null);

const TYPE_STYLES = {
    success: 'border-green-200 bg-green-50 text-green-700',
    error: 'border-red-200 bg-red-50 text-red-700',
    info: 'border-blue-200 bg-blue-50 text-blue-700',
};

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);

    const showToast = useCallback((message, type = 'info', duration = 2500) => {
        const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        setToasts((prev) => [...prev, { id, message, type }]);
        window.setTimeout(() => removeToast(id), duration);
    }, [removeToast]);

    const value = useMemo(() => ({ showToast }), [showToast]);

    return (
        <ToastContext.Provider value={value}>
            {children}
            <div className="fixed right-4 top-4 z-[100] flex w-[calc(100%-2rem)] max-w-sm flex-col gap-2">
                {toasts.map((toast) => (
                    <div key={toast.id} className={`rounded-lg border px-4 py-3 text-sm shadow-sm ${TYPE_STYLES[toast.type] || TYPE_STYLES.info}`}>
                        <div className="flex items-start justify-between gap-3">
                            <span>{toast.message}</span>
                            <button type="button" className="text-xs opacity-70 hover:opacity-100" onClick={() => removeToast(toast.id)}>
                                ปิด
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const ctx = useContext(ToastContext);
    if (!ctx) {
        throw new Error('useToast must be used within ToastProvider');
    }
    return ctx;
};
